export default "__VITE_PUBLIC_ASSET__1cd9f698__"